const messages = {
  name: 'Scheduled Job |||| Scheduled Jobs',
  fields: {
    scheduleId: 'Schdule Id',
    nextExecution: 'Next Execution',
    status: 'Status',
    notification: 'Notification',
    actions: 'Actions',
  },
  filters: {
    account: 'Account',
    application: 'Application',
    group: 'Group',
    all: 'All',
  },
  actions: {
    viewDetails: 'View Details',
    reschedule: 'Reschedule',
    pause: 'Pause',
    resume: 'Resume',
    delete: 'Delete',
  },
  dialog: {
    notificationDetails: 'Notification Details',
  },
  deleteDialog: {
    title: 'Delete schedule %{id}?',
    content: 'The scheduled send is cancelled. This cannot be undone.',
  },
  rescheduleDialog: {
    title: 'Reschedule send',
    datetime: 'New date and time',
  },
  notifications: {
    deleted: 'Schedule deleted.',
    paused: 'Schedule paused.',
    resumed: 'Schedule resumed.',
    rescheduled: 'Schedule updated.',
    loadAccountsFailed: 'Failed to load accounts',
  },
};

export default messages;
